<svelte:head>

    <title>Bernhard Esperester - Online Portfolio</title>

</svelte:head>

<Router>

    <div class="app">

        <Navigation />

        <Route path="/" component={Welcome} />
    
        <Route path="/blog" component={Blog} />
    
        <Route path="/blog/:id" component={Blog} />
    
        <Footer />
    
    </div>

</Router>

<style>
    .app {
        width: 100%;
        position: relative;
    }
</style>

<script>
    // components
    import Router from 'components/Router.html'
    import Route from 'components/Route.html'

    // compounds
    import Footer from 'views/compounds/Footer.html'
    import Navigation from 'views/compounds/Navigation.html'

    // Views
    import Welcome from 'views/Welcome.html'
    import Blog from 'views/Blog.html'
    import AboutMe from 'views/AboutMe.html'
    
    export default {
        components: {
            Router,
            Footer,
            Route,
            Navigation
        },
        data() {
            return {
                Welcome,
                Blog,
                AboutMe,
                history
            }
        }
    }
</script>